import { Injectable } from '@angular/core';
import type { HelpdeskTaskPageInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-page.dto';
import type { HelpdeskTaskStatusFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-status-find.dto';
import { HelpdeskTaskTypeFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-find.dto';
import { HelpdeskTaskPersonalAccountQueryInterface } from '@zaoblako/shared/modules/helpdesk/dto/task/helpdesk-task-personal-account-query.dto';
import type { CommentaryFileFindInterface } from '@zaoblako/shared/modules/storage/dtos/commentary-file-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountHdTaskService extends BaseService {
  protected baseUrl = '/personal-account/helpdesk/task';

  public findWithPagination(queryParams: HelpdeskTaskPersonalAccountQueryInterface): Observable<HelpdeskTaskPageInterface> {
    return this.http.get<HelpdeskTaskPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public getFiles(taskId: number): Observable<CommentaryFileFindInterface[]> {
    return this.http.get<CommentaryFileFindInterface[]>(`${this.baseUrl}/${taskId}/files`);
  }

  public getTaskTypes(): Observable<HelpdeskTaskTypeFindInterface[]> {
    return this.http.get<HelpdeskTaskTypeFindInterface[]>('/personal-account/helpdesk/task-type');
  }

  public getTaskStatuses(): Observable<HelpdeskTaskStatusFindInterface[]> {
    return this.http.get<HelpdeskTaskStatusFindInterface[]>('/personal-account/helpdesk/task-status');
  }
}
